import type { WebSaleAvailabilityStatus } from 'autogen/swagger/all';
import { formatReact } from 'modules/helpers/strings';
import StatusItem from 'components/StatusItem';
import { Typography } from 'components/generic/typography';
import { useTranslation } from 'react-i18next';
import {
    Discontinued,
    OnlineOnly,
    SoldOutOnline
} from 'autogen/translation-keys/trans-website-product-websaleavailability';

type WebsaleAvailabilityProps = {
    availability: WebSaleAvailabilityStatus;
};

export default function WebsaleAvailability(props: WebsaleAvailabilityProps) {
    const { availability } = props;
    const { t } = useTranslation();

    switch (availability) {
        case 'Discontinued':
            return (
                <StatusItem color="Red" bulletSize={10}>
                    {t(Discontinued)}
                </StatusItem>
            );
        case 'OnlineOnly':
            return <Typography.Body>{t(OnlineOnly)}</Typography.Body>;
        case 'SoldOutOnline':
            return (
                <StatusItem color="Red" bulletSize={10}>
                    {t(SoldOutOnline)}
                </StatusItem>
            );
        case 'Available':
        default:
            return null;
    }
}
